module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Pictograph.js"));
	}, "Pictograph");
}